import LoadingModalStyles from "./LoadingModalStyles";

const LoadingModal = (): JSX.Element => {
  return (
    <LoadingModalStyles>
      <section className="loading-modal"></section>
    </LoadingModalStyles>
  );
};

export default LoadingModal;
